"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@material-ui/core");
var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));
var _componentsLibrary = require("components-library");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _Mail = _interopRequireDefault(require("@material-ui/icons/Mail"));
var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));
var _classnames = _interopRequireDefault(require("classnames"));
var _BoatSearch = _interopRequireDefault(require("../BoatSearch/BoatSearch"));
var _TopBar = _interopRequireDefault(require("./TopBar"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: function root(props) {
      return {
        flexGrow: 1,
        border: "none",
        boxShadow: "none",
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        color: theme.palette.text.primary,
        borderBottom: props.hasHero ? "none" : "1px solid ".concat(theme.palette.divider),
        background: "linear-gradient(to bottom, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.25) 100%)",
        backdropFilter: "blur(2px)",
        position: "relative"
      };
    },
    brand: {
      maxWidth: "280px",
      display: "block",
      "&::after": {
        display: "none"
      }
    },
    list: {
      zIndex: 100,
      position: "absolute",
      background: "linear-gradient(165deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.95) 44%, rgba(255,255,255,1) 100%)",
      width: "180%",
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[1]
    },
    link: {
      textTransform: "none",
      "& :hover": {
        textTransform: "none"
      },
      "& .MuiSvgIcon-root": {
        paddingLeft: theme.spacing(1)
      }
    },
    mobileLink: {
      color: theme.palette.common.white,
      textDecoration: "none"
    },
    subLink: {
      color: theme.palette.text.secondary,
      textDecoration: "none"
    },
    drawer: {
      background: "linear-gradient(9deg, rgba(42,42,42,1) 0%, rgba(42,42,42,0.95) 69%, rgba(42,42,42,0.85) 100%)",
      height: "100vh",
      minWidth: "280px",
      display: "flex",
      flexDirection: "column"
    },
    drawerInner: {
      overflowY: "auto",
      overflowX: "hidden"
    },
    fab: {
      position: "absolute",
      bottom: theme.spacing(2),
      right: theme.spacing(2)
    }
  };
});
var Links = function Links(_ref) {
  var LinkComponent = _ref.LinkComponent,
    boatTypes = _ref.boatTypes,
    locations = _ref.locations,
    links = _ref.links,
    isMobile = _ref.isMobile,
    hasHero = _ref.hasHero;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (boatTypes || []).length > 0 && /*#__PURE__*/_react["default"].createElement(Link, {
    LinkComponent: LinkComponent,
    isMobile: isMobile,
    subLinks: boatTypes,
    title: "Boat Types",
    hasHero: hasHero
  }), (locations || []).length > 0 && /*#__PURE__*/_react["default"].createElement(Link, {
    LinkComponent: LinkComponent,
    isMobile: isMobile,
    subLinks: locations,
    title: "Locations",
    hasHero: hasHero
  }), (links || []).map(function (link, index) {
    return /*#__PURE__*/_react["default"].createElement(Link, {
      key: index,
      LinkComponent: LinkComponent,
      isMobile: isMobile,
      subLinks: link.nested,
      title: link.name,
      hasHero: hasHero,
      path: link.path
    });
  }), /*#__PURE__*/_react["default"].createElement(ContactLink, {
    LinkComponent: LinkComponent,
    hasHero: hasHero
  }));
};
var Link = function Link(_ref2) {
  var LinkComponent = _ref2.LinkComponent,
    title = _ref2.title,
    subLinks = _ref2.subLinks,
    isMobile = _ref2.isMobile,
    path = _ref2.path;
  var _useStyles = useStyles(),
    link = _useStyles.link,
    subLink = _useStyles.subLink,
    list = _useStyles.list,
    mobileLink = _useStyles.mobileLink;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var listItems = /*#__PURE__*/_react["default"].createElement(_core.List, {
    dense: true,
    component: "div",
    disablePadding: true
  }, (subLinks || []).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  }).map(function (subL, index) {
    return /*#__PURE__*/_react["default"].createElement(LinkComponent, {
      key: index,
      to: subL.path,
      className: isMobile ? mobileLink : subLink
    }, /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
      button: true
    }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      primary: subL.name
    })));
  }));
  var children = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    className: (0, _classnames["default"])(link, _defineProperty({}, mobileLink, isMobile)),
    onClick: function onClick() {
      return isMobile && setOpen(!open);
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
    primary: title
  }), open ? /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.Collapse, {
    "in": open,
    timeout: "auto",
    unmountOnExit: true,
    className: !isMobile ? list : null
  }, listItems));
  if (!path) {
    return isMobile ? /*#__PURE__*/_react["default"].createElement(_core.List, null, children) : /*#__PURE__*/_react["default"].createElement(_core.List, {
      disablePadding: true,
      onMouseOver: function onMouseOver() {
        return setOpen(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setOpen(false);
      }
    }, children);
  }
  return subLinks.length > 0 ? isMobile ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(LinkComponent, {
    to: path,
    className: isMobile ? mobileLink : subLink
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    className: (0, _classnames["default"])(link)
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
    primary: title
  }))), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    pl: 1
  }, listItems)) : /*#__PURE__*/_react["default"].createElement(LinkComponent, {
    to: path,
    className: isMobile ? mobileLink : subLink,
    onMouseOver: function onMouseOver() {
      return setOpen(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.List, {
    disablePadding: true
  }, children)) : /*#__PURE__*/_react["default"].createElement(LinkComponent, {
    to: path,
    className: isMobile ? mobileLink : subLink
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    className: (0, _classnames["default"])(link)
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
    primary: title
  })));
};
var ContactLink = function ContactLink(_ref3) {
  var LinkComponent = _ref3.LinkComponent;
  var _useStyles2 = useStyles(),
    link = _useStyles2.link;
  return /*#__PURE__*/_react["default"].createElement(LinkComponent, {
    to: "/contact/"
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    className: (0, _classnames["default"])(link)
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
    primary: "Contact"
  }), /*#__PURE__*/_react["default"].createElement(_Mail["default"], null)));
};
var MobileLinks = function MobileLinks(_ref4) {
  var boatTypes = _ref4.boatTypes,
    locations = _ref4.locations,
    links = _ref4.links,
    LinkComponent = _ref4.LinkComponent,
    hasHero = _ref4.hasHero,
    boats = _ref4.boats,
    onBoatSelect = _ref4.onBoatSelect;
  var _useStyles3 = useStyles({
      hasHero: hasHero
    }),
    drawer = _useStyles3.drawer,
    drawerInner = _useStyles3.drawerInner,
    fab = _useStyles3.fab;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    edge: "start",
    color: "inherit",
    "aria-label": "menu",
    style: {
      zIndex: 999
    },
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Menu["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.Drawer, {
    open: open,
    onClose: function onClose() {
      return setOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.List, {
    className: drawer
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    p: 2,
    sx: {
      background: "white"
    }
  }, /*#__PURE__*/_react["default"].createElement(_BoatSearch["default"], {
    boats: boats || [],
    onBoatSelect: onBoatSelect
  })), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: drawerInner
  }, /*#__PURE__*/_react["default"].createElement(Links, {
    LinkComponent: LinkComponent,
    boatTypes: boatTypes,
    locations: locations,
    isMobile: true,
    links: links || []
  })), /*#__PURE__*/_react["default"].createElement(_core.Fab, {
    size: "medium",
    className: fab,
    onClick: function onClick() {
      return setOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], null)))));
};
function Header(_ref5) {
  var LinkComponent = _ref5.LinkComponent,
    isMobile = _ref5.isMobile,
    boatTypes = _ref5.boatTypes,
    locations = _ref5.locations,
    links = _ref5.links,
    topLinks = _ref5.topLinks,
    hasHero = _ref5.hasHero,
    useLoad = _ref5.useLoad,
    boats = _ref5.boats,
    onBoatSelect = _ref5.onBoatSelect;
  var _useStyles4 = useStyles({
      hasHero: hasHero
    }),
    root = _useStyles4.root,
    brand = _useStyles4.brand;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (topLinks || []).length > 0 && /*#__PURE__*/_react["default"].createElement(_TopBar["default"], {
    LinkComponent: LinkComponent,
    links: topLinks
  }), /*#__PURE__*/_react["default"].createElement(_core.AppBar, {
    position: hasHero ? "absolute" : "static",
    color: "transparent",
    className: root
  }, /*#__PURE__*/_react["default"].createElement(_core.Container, null, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    type: "flex",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(LinkComponent, {
    to: "/",
    className: brand
  }, /*#__PURE__*/_react["default"].createElement(_componentsLibrary.Brand, {
    useLoad: useLoad
  }))), /*#__PURE__*/_react["default"].createElement(_core.Box, null, isMobile ? /*#__PURE__*/_react["default"].createElement(MobileLinks, {
    boatTypes: boatTypes,
    locations: locations,
    links: links,
    LinkComponent: LinkComponent,
    hasHero: hasHero,
    onBoatSelect: onBoatSelect,
    boats: boats
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Hidden, {
    implementation: "css",
    smUp: true
  }, /*#__PURE__*/_react["default"].createElement(MobileLinks, {
    boatTypes: boatTypes,
    locations: locations,
    links: links,
    LinkComponent: LinkComponent,
    hasHero: hasHero,
    onBoatSelect: onBoatSelect,
    boats: boats
  })), /*#__PURE__*/_react["default"].createElement(_core.Hidden, {
    implementation: "css",
    xsDown: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    sx: {
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/_react["default"].createElement(_BoatSearch["default"], {
    boats: boats || [],
    onBoatSelect: onBoatSelect
  })), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    type: "flex",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(Links, {
    LinkComponent: LinkComponent,
    boatTypes: boatTypes,
    locations: locations,
    isMobile: false,
    links: links || [],
    hasHero: hasHero
  })))))))));
}
Header.propTypes = {
  LinkComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  isMobile: _propTypes["default"].bool,
  onBoatSelect: _propTypes["default"].func,
  boats: _propTypes["default"].arrayOf(_propTypes["default"].object),
  locations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    path: _propTypes["default"].string
  })),
  boatTypes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    path: _propTypes["default"].string
  })),
  hasHero: _propTypes["default"].bool,
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    path: _propTypes["default"].string,
    nested: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      name: _propTypes["default"].string,
      path: _propTypes["default"].string
    }))
  })),
  topLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    path: _propTypes["default"].string,
    nested: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      name: _propTypes["default"].string,
      path: _propTypes["default"].string
    }))
  }))
};
Header.defaultProps = {
  hasHero: true
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Header);